import { getConfigBoolean } from "./env";

export function checkImIdEnabled(): boolean {
  return getConfigBoolean('REACT_APP_ENABLE_IMID', false);
}